import { Component, Vue, Ref } from "vue-property-decorator";
import InnerBody from './components/InnerBody'
import InnerBodys from './components/InnerBodys'
import CreatModal from './components/CreatModal.vue'
import IndexPrint from '@/components/CodeModel/index.vue'
import { exportMaintainRecord } from '@/api/api'
import { EmployeeSearchDTO, EmployeeServiceProxy } from '@/service-proxies/app-v2/employee.service-proxies'
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies';
import { MaintainRecordServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies';

const esp = new EmployeeServiceProxy()
const dtsp = new DeviceTypeServiceProxy()
const mrsp = new MaintainRecordServiceProxy()
@Component({
  components: {
    InnerBody,
    InnerBodys,
    CreatModal,
    IndexPrint
  }
})
export default class Alarm extends Vue {
  showCode=false
  valObj={
    name:'',
    code:'',
    index:''
  }
  selectedRows=[]
  dataShiftOrder = []
  ShiftMaterialList = []
  selectedRowKeys = []
  addNewVisible = false
  editVisible = false
  searchKey = ""
  searchStatus = 0
  searchType = ""
  paginationOrder = {
    pageSize: 10,
    current: 1,
  }
  total = 0
  orderLoading = false
  orderMaterialLoading = false
  employeesList = [] // 员工
  height = 300
  tableScrollHeight = 300
  selectId = ""
  resizeTimer = null
  deviceTypeList = []

  mounted() {
    this.$nextTick(() => {
      esp.getPageEmployees(1,{statusList: [1]} as EmployeeSearchDTO,"",999999).then(res =>{
        this.employeesList = res.records
      })
      const search = {
        keyWord:"",
        query:{ current: 1, size:-1}
      } as any
      dtsp.pageDeviceType(search).then(res =>{
        this.deviceTypeList = res.records
        this.getList()
      })
    })
  }

  updated(){
    const div = document.body.clientHeight
    this.tableScrollHeight = (div - 360) /2
    this.height = (div - 350) /2
  }

  changeY(){
    if(this.resizeTimer){
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(function(){
      const div = document.getElementById('ware-topmodal')
      this.tableScrollHeight = div.clientHeight
      const bodyTableBody: any = document.querySelector('#ware-topmodal .ant-table-body')
      if(bodyTableBody){
        bodyTableBody.style.maxHeight = (this.tableScrollHeight - 88) + 'px'
      }
    },100)
  }
  print(){
    this.getData()
    this.showCode=true
  }
  cancel(){
    this.showCode=false
  }
  getList(){
      this.dataShiftOrder = []
      this.ShiftMaterialList = []
      this.orderLoading = true
      const deviceType = this.deviceTypeList.find(res => res.code === this.searchType)
      const maintainRecord = {
        deviceId: "",
        deviceTypeId: (deviceType !== undefined ? deviceType.id : ""),
        filterPlus: false,
        keyWord: this.searchKey,
        param: {},
        recordStatus: this.searchStatus
      }as any
      this.orderLoading = true
      mrsp.queryMaintainRecordPage(this.paginationOrder.current,maintainRecord,this.paginationOrder.pageSize).then(res =>{
        this.dataShiftOrder = res.records
        if(this.selectId){
          this.onClickRow(this.selectId)
        } else if(res.records && res.records.length > 0){
          this.onClickRow(res.records[0].id)
        }
        this.total = Number(res.total)
        this.orderLoading = false
      }).catch(() => {this.orderLoading = false})
  }

  reload(){
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.addNewVisible = false
    this.getList()
  }
  
  onSearch(value) {
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.selectId = ""
    this.selectedRowKeys = []
    this.searchKey = value
    this.getList()
  }
  
  handleChangeStatus(value){
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.selectId = ""
    this.selectedRowKeys = []
    this.searchStatus = value
    this.getList()
  }

  handleChangeType(value){
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.selectId = ""
    this.selectedRowKeys = []
    this.searchType = value
    this.getList()
  }
  
  addNew(){
    this.addNewVisible = true
  }

  addClose(){
    this.addNewVisible = false
  }
  
  getData() {
    this.selectedRows = []
    this.selectedRowKeys.map(id =>{
      this.dataShiftOrder.map(item => {
        if(id === item.id) {
          this.selectedRows.push({
            code: item.planCode,
            name: item.deviceName
          })
        }
      })
    })
  }

  onSelectChange(selectedRowKeys,selectedRows) {
    this.selectedRowKeys = selectedRowKeys;
    if(selectedRowKeys.length == 1 ){
      this.onClickRow(selectedRowKeys[0])
    }
  }

  handleTableChange(data) {
    this.paginationOrder = {
      pageSize: data.pageSize,
      current: data.current
    }
    this.selectId = ""
    this.selectedRowKeys = []
    this.getList()
  }

  onClickRow(value){
    this.selectId = value
    this.selectedRowKeys = [value]
    this.orderMaterialLoading = true
    mrsp.getMaintainRecord(value).then(res =>{
      this.ShiftMaterialList = res.maintainRecordItemVoList
      this.orderMaterialLoading = false
    })
  }
    
  beforeDestroy(){
    clearTimeout(this.resizeTimer)
    this.resizeTimer = null
  }

  handleMenuClick(value){
    const deviceType = this.deviceTypeList.find(res => res.code === this.searchType)
    const data = {
      deviceId: "",
      deviceTypeId: (deviceType !== undefined ? deviceType.id : ""),
      exportSelected: true,
      keyWord: this.searchKey,
      recordStatus: this.searchStatus,
      selectedRecords: []
    }
    if(value == 1){
      data.exportSelected = true
      data.selectedRecords = this.selectedRowKeys
    } else {
      data.exportSelected = false
      data.selectedRecords = []
    }
    exportMaintainRecord(data).then(res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_equipment_maintain_records')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }
  render() {
    return (
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="display:flex;justify-content: space-between">
          <div>
            <a-button type="primary" v-acl="page_maintenance_records_add_new_reco" onClick={() => this.addNew()} style="margin-right: 8px;">{ this.$t('page_plan_maintenance_add_maintenance_record')}</a-button>
            <a-dropdown>
              <a-menu slot="overlay" onClick={value => this.handleMenuClick(value.key)}>
                <a-menu-item key={1} disabled={this.selectedRowKeys.length === 0}>
                  { this.$t('page_product_confirm_select_export') }
                </a-menu-item>
                <a-menu-item key={2} disabled={this.dataShiftOrder.length === 0}>
                  { this.$t('page_product_confirm_search_export') }
                </a-menu-item>
              </a-menu>
              <a-button v-acl="page_maintenance_records_export_re" style="margin-right: 8px;">{ this.$t('page_product_export')}<a-icon type="down" /> </a-button>
            </a-dropdown>
            <a-button v-acl="page_maintenance_plan_export_plan" onClick={()=>this.print()} disabled={this.selectedRowKeys.length === 0}>{this.$t("page_print_code")}</a-button>
          </div>
          <div>
            <a-select 
            showSearch={true}
            optionFilterProp="children"
            value={this.searchType} placeholder={ this.$t('page_business_device_type') } style="width: 120px;margin-right: 8px;" onChange={value => this.handleChangeType(value)}>
              <a-select-option value={""}>
                { this.$t('page_plan_maintenance_all_types') }
              </a-select-option>
              { this.deviceTypeList.map(item => {
                return <a-select-option value={ item.code } >
                        { item.name }
                      </a-select-option>
              })}
            </a-select>
            <a-select value={this.searchStatus} style="width: 120px;margin-right: 8px;" onChange={value => this.handleChangeStatus(value)}>
              <a-select-option value={0}>
                { this.$t('page_plan_maintenance_all_states') }
              </a-select-option>
              <a-select-option value={1}>
                { this.$t('page_plan_maintenance_to_be_maintained') }
              </a-select-option>
              <a-select-option value={2}>
                { this.$t('page_plan_maintenance_confirmed') }
              </a-select-option>
            </a-select>
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_my_document_advanced') }</a-button> */}
            <a-input-search placeholder={this.$t('keyword')} style="width: 200px" enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:100%">
          <div id="ware-topmodal" style="width:100%;height: calc(50% - 4px);position: relative;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff;overflow:auto">
            <inner-body
              height={this.tableScrollHeight}
              selectId={this.selectId}
              selectedRowKeys={this.selectedRowKeys}
              employeesList={this.employeesList}
              data={this.dataShiftOrder}
              current={this.paginationOrder.current}
              total={this.total}
              loading={this.orderLoading}
              pageSize={this.paginationOrder.pageSize}
              onOnSelectChange={(value,values )=> this.onSelectChange(value,values) }
              onHandleTableChange={value => this.handleTableChange(value) }
              onClickRow={value => this.onClickRow(value)}
              onReload={() => this.reload()}
              ></inner-body>
          </div>
          <div v-resize={{axis: 'y', cb: this.changeY }}></div>
          <div style="width:100%;height: calc(50% - 4px);position: relative;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff;overflow:auto">
            <inner-bodys
              height={this.height}
              data={this.ShiftMaterialList}
              loading={this.orderMaterialLoading}
            ></inner-bodys>
          </div>
        </div>
        {
         <index-print
          visible={this.showCode}
          dataList={this.selectedRows}
          onPrint={()=>this.print()}
          onCancel={()=>this.cancel()}
           ></index-print>
        }
        {this.addNewVisible ? <creat-modal
          employeesList={this.employeesList}
          visible={this.addNewVisible}
          onClose={() => this.addClose()}
          onReload={() => this.reload()}></creat-modal> : null }          
      </blank-view>
    )
  }
}